var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reply" },
    [
      _c("div", { staticClass: "cont-box" }, [
        _c(
          "div",
          { staticClass: "title" },
          [
            _c("Title", { attrs: { text: "答辩申请" } }),
            _c(
              "div",
              [
                _c(
                  "el-form",
                  {
                    ref: "search",
                    staticClass: "search-form",
                    attrs: {
                      slot: "search",
                      inline: true,
                      model: _vm.condition,
                      rules: _vm.searchRules,
                      "label-width": "80px",
                    },
                    slot: "search",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                        },
                      },
                      [
                        _c("div", [
                          _c(
                            "div",
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "paper_plan_student_id" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "300px" },
                                      attrs: {
                                        placeholder: "请选择论文计划",
                                        clearable: "",
                                        filterable: "",
                                      },
                                      model: {
                                        value:
                                          _vm.condition.paper_plan_student_id,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.condition,
                                            "paper_plan_student_id",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "condition.paper_plan_student_id",
                                      },
                                    },
                                    _vm._l(_vm.thesisPlanList, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.title,
                                          value: item.id,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.loadData },
                                    },
                                    [_vm._v("确认")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm.isShowDuplicate
                          ? _c("div", [
                              _c("div", { staticClass: "btn-box" }, [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _vm.isShowDuplicateBtn
                                          ? _c(
                                              "el-button",
                                              {
                                                staticClass: "link-btn",
                                                attrs: { type: "primary" },
                                                on: {
                                                  click:
                                                    _vm.duplicateCheckClick,
                                                },
                                              },
                                              [_vm._v("提交申请")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c(
                                "div",
                                [
                                  _c("el-form-item", [
                                    _c("span", [
                                      _vm._v(
                                        "答辩申请截止时间：" +
                                          _vm._s(_vm.end_apply_time)
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          [
            _c(
              "el-table",
              {
                attrs: {
                  data: _vm.list,
                  headerRowClassName: "uni-primary-table-header",
                  stripe: "",
                  border: "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "", align: "center", label: "流程标题" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(row.student_title) +
                                " + " +
                                _vm._s(row.process_title) +
                                " + " +
                                _vm._s(row.created_at)
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "sign_img",
                    align: "center",
                    label: "手写签名",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("img", {
                            staticStyle: {
                              width: "200px",
                              height: "40px",
                              "object-fit": "contain",
                            },
                            attrs: { src: row.sign_img, alt: "" },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "score_teacher_title",
                    align: "center",
                    label: "评分老师",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "result.percentage",
                    align: "center",
                    label: "查重相似率",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "score_pass_status",
                    align: "center",
                    label: "设计资料评分状态",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("scorePassStatusFliter")(
                                  row.score_pass_status
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "paper_score",
                    align: "center",
                    label: "设计资料最终得分",
                  },
                }),
                _c("el-table-column", {
                  attrs: { prop: "remark", align: "center", label: "评语" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "dup_check_status",
                    align: "center",
                    label: "查重状态",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("dupCheckStatusFilter")(
                                  row.dup_check_status
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "check_remark",
                    align: "center",
                    label: "备注",
                  },
                }),
                _c("el-table-column", {
                  attrs: { align: "center", label: "操作", width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          row.is_redo == 1
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "link-btn",
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.duplicateCheckClickRedo(row)
                                    },
                                  },
                                },
                                [_vm._v("重新提交查重文件")]
                              )
                            : _vm._e(),
                          row.is_resubmit == 1
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "link-btn",
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.resInfoClick(row)
                                    },
                                  },
                                },
                                [_vm._v("重提设计资料")]
                              )
                            : _vm._e(),
                          row.is_check == 1
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "link-btn",
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.enterDetection(row)
                                    },
                                  },
                                },
                                [_vm._v("进入检测")]
                              )
                            : _vm._e(),
                          row.dup_check_status == 1
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "link-btn",
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.duplicateCheckResClick(row)
                                    },
                                  },
                                },
                                [_vm._v("查重结果")]
                              )
                            : _vm._e(),
                          row.score_pass_status == 0
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "link-btn",
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.revokeClick(row)
                                    },
                                  },
                                },
                                [_vm._v("撤销")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          staticClass: "duplicateCheck",
          attrs: {
            title: _vm.isResubmit ? "重提设计资料" : "提交申请",
            visible: _vm.isShowDuplicateCheck,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowDuplicateCheck = $event
            },
            close: _vm.duplicateCheckClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog" },
            [
              _c(
                "el-form",
                {
                  ref: "duplicateCheck",
                  attrs: {
                    model: _vm.duplicateCheckData,
                    rules: _vm.duplicateCheckRules,
                    "label-width": "160px",
                  },
                },
                [
                  _vm.professionId == 16 ||
                  _vm.professionId == 5 ||
                  _vm.professionId == 13
                    ? _c(
                        "div",
                        [
                          !_vm.isResubmit
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "查重文件：",
                                    prop: "files_url",
                                  },
                                },
                                [
                                  _c("FalConUpload", {
                                    ref: "uploadDuplicateCheck",
                                    attrs: {
                                      listStyle: "text",
                                      accept: ".docx,.doc,.pdf,.txt",
                                      limit: 1,
                                      isFile: true,
                                      isAccept: true,
                                    },
                                    on: {
                                      handleRemove:
                                        _vm.duplicateCheckHandleRemove,
                                      handleChange:
                                        _vm.duplicateCheckHandleChange,
                                    },
                                  }),
                                  _c("div", [
                                    _c("span", { staticClass: "tips" }, [
                                      _vm._v(
                                        "说明：查重文件只需要上传设计说明,只能上传docx,doc,pdf,txt文件"
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "最终设计资料:",
                                prop: "files_url2",
                              },
                            },
                            [
                              _c("FalConUpload", {
                                ref: "uploadFile",
                                attrs: {
                                  listStyle: "text",
                                  accept: "",
                                  limit: 20,
                                  multiple: true,
                                  isFile: true,
                                  isAccept: false,
                                },
                                on: {
                                  handleRemove: _vm.handleRemoveFile,
                                  handleChange: _vm.handleChangeFile,
                                },
                              }),
                              _c("div", { staticClass: "tips" }, [
                                _vm._v(
                                  "说明：将设计的所有资料转换成PDF文化后压缩为ZIP文件上传"
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm.professionId == 11
                    ? _c(
                        "div",
                        [
                          !_vm.isResubmit
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "查重文件：",
                                    prop: "files_url",
                                  },
                                },
                                [
                                  _c("FalConUpload", {
                                    ref: "uploadDuplicateCheck",
                                    attrs: {
                                      listStyle: "text",
                                      accept: ".docx,.doc,.pdf,.txt",
                                      limit: 1,
                                      isFile: true,
                                      isAccept: true,
                                    },
                                    on: {
                                      handleRemove:
                                        _vm.duplicateCheckHandleRemove,
                                      handleChange:
                                        _vm.duplicateCheckHandleChange,
                                    },
                                  }),
                                  _c("div", [
                                    _c("span", { staticClass: "tips" }, [
                                      _vm._v(
                                        "说明：只能上传docx,doc,pdf,txt文件,只上传设计论文资料用于查重。设计的程序和演示视频不要上传"
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "最终设计资料:",
                                prop: "files_url2",
                              },
                            },
                            [
                              _c("FalConUpload", {
                                ref: "uploadFile",
                                attrs: {
                                  listStyle: "text",
                                  accept:
                                    ".pdf,.zip,.rar,.xls,.xlsx,.doc,.docx,.ppt,.pptx",
                                  limit: 20,
                                  multiple: true,
                                  isFile: true,
                                  isAccept: false,
                                },
                                on: {
                                  handleRemove: _vm.handleRemoveFile,
                                  handleChange: _vm.handleChangeFile,
                                },
                              }),
                              _c("div", { staticClass: "tips" }, [
                                _vm._v(
                                  "说明：将设计论文、设计程序及演示压缩为ZIP文件上修"
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "最终设计资料：",
                                prop: "files_url",
                              },
                            },
                            [
                              _c("FalConUpload", {
                                ref: "uploadDuplicateCheck",
                                attrs: {
                                  listStyle: "text",
                                  accept: ".docx,.doc,.pdf,.txt",
                                  limit: 1,
                                  isFile: true,
                                  isAccept: true,
                                },
                                on: {
                                  handleRemove: _vm.duplicateCheckHandleRemove,
                                  handleChange: _vm.duplicateCheckHandleChange,
                                },
                              }),
                              _c("div", [
                                _c("span", { staticClass: "tips" }, [
                                  _vm._v("说明：只能上传docx,doc,pdf,txt文件"),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                  !_vm.isResubmit
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "手写签名:", prop: "sign_img" } },
                        [
                          _c("esignHandle", {
                            ref: "duplicateCheckEsignHandle",
                            attrs: {
                              selectSignImg: _vm.duplicateCheckData.sign_img,
                            },
                            on: {
                              "update:selectSignImg": function ($event) {
                                return _vm.$set(
                                  _vm.duplicateCheckData,
                                  "sign_img",
                                  $event
                                )
                              },
                              "update:select-sign-img": function ($event) {
                                return _vm.$set(
                                  _vm.duplicateCheckData,
                                  "sign_img",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isShowDuplicateCheck = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.duplicateCheckLoading,
                  },
                  on: { click: _vm.duplicateCheckSubmit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "duplicateCheckRedo",
          attrs: {
            title: "重新提交查重文件",
            visible: _vm.isShowDuplicateCheckRedo,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowDuplicateCheckRedo = $event
            },
            close: _vm.duplicateCheckCloseRedo,
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog" },
            [
              _c(
                "el-form",
                {
                  ref: "duplicateCheckRedo",
                  attrs: {
                    model: _vm.duplicateCheckRedoData,
                    rules: _vm.duplicateCheckRedoRules,
                    "label-width": "160px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "查重文件：", prop: "files_url" } },
                    [
                      _c("FalConUpload", {
                        ref: "uploadDuplicateCheckRedo",
                        attrs: {
                          listStyle: "text",
                          accept: ".docx,.doc,.pdf,.txt",
                          limit: 1,
                          isFile: true,
                          isAccept: true,
                        },
                        on: {
                          handleRemove: _vm.duplicateCheckHandleRemoveRedo,
                          handleChange: _vm.duplicateCheckHandleChangeRedo,
                        },
                      }),
                      _c("div", [
                        _c("span", { staticClass: "tips" }, [
                          _vm._v(
                            "说明：查重文件只需要上传设计说明,只能上传docx,doc,pdf,txt文件"
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isShowDuplicateCheckRedo = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.duplicateCheckLoadingRedo,
                  },
                  on: { click: _vm.duplicateCheckSubmitRedo },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "duplicateCheckRes",
          attrs: {
            title: "查重结果",
            visible: _vm.isShowDuplicateCheckRes,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowDuplicateCheckRes = $event
            },
            close: _vm.duplicateCheckResClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog" },
            [
              !_vm.duplicateRes.paperguid
                ? _c("span", { staticClass: "tips" }, [_vm._v("暂无结果")])
                : _c("el-scrollbar", { staticStyle: { height: "300px" } }, [
                    _c("div", { staticClass: "item" }, [
                      _c("span", { staticClass: "name" }, [
                        _vm._v("检测报告编码："),
                      ]),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.duplicateRes.paperguid)),
                      ]),
                    ]),
                    _c("div", { staticClass: "item" }, [
                      _c("span", { staticClass: "name" }, [
                        _vm._v("检测文章标题："),
                      ]),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.duplicateRes.papertitle)),
                      ]),
                    ]),
                    _c("div", { staticClass: "item" }, [
                      _c("span", { staticClass: "name" }, [_vm._v("相似率：")]),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.duplicateRes.percentage)),
                      ]),
                    ]),
                    _c("div", { staticClass: "item" }, [
                      _c("span", { staticClass: "name" }, [
                        _vm._v("检测时间："),
                      ]),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.duplicateRes.checkdate)),
                      ]),
                    ]),
                    _c("div", { staticClass: "item" }, [
                      _c("span", { staticClass: "name" }, [
                        _vm._v("检测字数："),
                      ]),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.duplicateRes.paperword)),
                      ]),
                    ]),
                    _c("div", { staticClass: "item" }, [
                      _c("span", { staticClass: "name" }, [
                        _vm._v("在线预览链接："),
                      ]),
                      _c("span", { staticClass: "value" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.duplicateRes.paperviewurl,
                              target: "_blank",
                            },
                          },
                          [_vm._v(_vm._s(_vm.duplicateRes.paperviewurl))]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "item" }, [
                      _c("span", { staticClass: "name" }, [
                        _vm._v("下载报告地址："),
                      ]),
                      _c("span", { staticClass: "value" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.duplicateRes.paperdownurl,
                              target: "_blank",
                            },
                          },
                          [_vm._v(_vm._s(_vm.duplicateRes.paperdownurl))]
                        ),
                      ]),
                    ]),
                  ]),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isShowDuplicateCheckRes = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }